import { createSlice } from '@reduxjs/toolkit'
import { getSignUpPageProgram } from '../actions/programActions'
import { addStudentsToWaitlist } from '../actions/waitlistActions'

const initialState = {
  course: {},
  isLoading: false,
  errors: {},
  detailsTabs: [],
  currentDetailTab: 'Description',
  isJoinedModalOpen: false,
  isWaitlistModalOpen: false,
  isJoinActionLoading: false,
}

const programPresentationSlice = createSlice({
  name: 'programPresentation',
  initialState,
  reducers: {
    resetErrors: state => {
      state.errors = {}
    },
    resetCurrentDetailTab: state => {
      state.currentDetailTab = 'Description'
    },
    setCurrentDetailTab: (state, action) => {
      state.currentDetailTab = action.payload
    },
    setProgram: (state, action) => {
      state.course = action.payload.program
      state.detailsTabs = action.payload.detailsTabs
    },
    setIsJoinedModalOpen: (state, action) => {
      state.isJoinedModalOpen = action.payload
    },
    setIsWaitlistModalOpen: (state, action) => {
      state.isWaitlistModalOpen = action.payload
    },
  },
  extraReducers: {
    // getPresentationProgram
    [getSignUpPageProgram.pending]: state => {
      state.isLoading = true
    },
    [getSignUpPageProgram.fulfilled]: (state, action) => {
      const course = action.payload.course

      state.course = course
      state.detailsTabs = ['Description']
      if (course.schedule) {
        state.detailsTabs.push('Schedule')
      }
      if (course.series && course.series.length > 0) {
        state.detailsTabs.push('9 Hole Events')
      }
      if (course.materials.length + course.packages.length > 0) {
        state.detailsTabs.push('Pricing')
      }
      state.isLoading = false
    },
    [getSignUpPageProgram.rejected]: (state, action) => {
      state.errors = action.payload
      state.isLoading = false
    },
    [addStudentsToWaitlist.pending]: (state) => {
      state.isJoinActionLoading = true
    },
    [addStudentsToWaitlist.fulfilled]: (state, action) => {
      state.course.waitlistedStudents = action.payload.waitlistedStudents
      state.isJoinActionLoading = false
    },
    [addStudentsToWaitlist.rejected]: (state) => {
      state.isJoinActionLoading = false
    },
  },
})

export const {
  resetErrors,
  resetCurrentDetailTab,
  setCurrentDetailTab,
  setProgram,
  setIsJoinedModalOpen,
  setIsWaitlistModalOpen,
} = programPresentationSlice.actions

export default programPresentationSlice.reducer
